<template>
    <div>
        <h5 v-html="$t('filter.titles.weekdays')"  />
        <b-select :options="this.options" @input="transmitNewValue" v-model="selected" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            selected: 'all',
            options: [
                { value: 'all', text: this.$t('filter.weekdays.all') },
                { value: 'workweek', text: this.$t('filter.weekdays.workweek') },
                { value: 'weekend', text: this.$t('filter.weekdays.weekend') },
            ]
        }
    },
    methods: {
        transmitNewValue() {
            this.$emit("transmit", this.selected, 'weekdays');
        }
    },

}
</script>

<style></style>